// extracted by mini-css-extract-plugin
export default {"bigText":"TopSection_bigText__o13je","span":"TopSection_span__hfltd"};